import React, { useEffect } from "react";
import { TanyaSearchBlock } from "components/tanya-search-block/tanya-search-block";
import { FAQBlock } from "components/faq-block/faq-block";
import { HomeSEO } from "seo/home.seo";
import { HomeMain } from "styles/pages/home.styles";
import { HeroLeadGenerationSection } from "components/lead-generation-v2/hero-lead-generation-section/hero-lead-generation-section";
import { MoneyBackGuaranteeAppDownload } from "components/money-back-guarantee-app-download/money-back-guarantee-app-download";
import { useBoolean } from "hooks/use-boolean/use-boolean";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useTanyaContext } from "stores/tanya/tanya-context";
import { getLeadSourceFromPath } from "utils/utils";
import { BimbelLoggedInBanner } from "components/kelas-live/bimbel-logged-in-banner/bimbel-logged-in-banner";
import { useAuth } from "stores/auth/auth-context";
import { UspSection } from "components/usp-section/usp-section";
import { PriceListSection } from "components/price-list-section/price-list-section";
import { TestimonialsSection } from "components/testimonials-section/testimonials-section";

const LeadGenerationModal = dynamic(
  () =>
    import(
      "components/lead-generation-v2/lead-generation-modal/lead-generation-modal"
    )
);

const ContactMe = dynamic(() => import("components/contact-me/contact-me"));

const Home: React.FC = () => {
  const [showLeadGenerationModal, setShowLeadGenerationModal] =
    useBoolean(false);
  const {
    user: { isUserLoggedIn, userData }
  } = useAuth();

  const { contactMeForm } = useTanyaContext();
  const router = useRouter();
  const { utm_campaign, utm_source, utm_medium, utm_term, utm_content } =
    router.query;
  const leadSource = getLeadSourceFromPath(router.pathname);

  useEffect(() => {
    if (
      isUserLoggedIn &&
      userData?.primary_user &&
      userData?.primary_user?.profile_state === "INCOMPLETE"
    ) {
      router.push({
        pathname: "/user/register/add-location",
        query: router.query
      });
    }
  }, [isUserLoggedIn, userData?.primary_user?.profile_state]);

  return (
    <HomeMain>
      <HomeSEO />
      {isUserLoggedIn && (
        <BimbelLoggedInBanner name={userData.primary_user.full_name} />
      )}
      {!isUserLoggedIn && (
        <HeroLeadGenerationSection // No conditional rendering
          onPriceInfoCTAClick={() => setShowLeadGenerationModal.on()}
          source="Home"
        />
      )}
      <UspSection />
      <PriceListSection />
      <TestimonialsSection />
      <MoneyBackGuaranteeAppDownload />
      <FAQBlock showExpandCTA />
      <TanyaSearchBlock bgTheme="light" />
      {contactMeForm.show && (
        <ContactMe
          metaData={contactMeForm.metaData}
          onClose={() => contactMeForm.setContactMeFormData({ show: false })}
          leadSource={leadSource}
        />
      )}
      {showLeadGenerationModal && (
        <LeadGenerationModal
          onClose={() => setShowLeadGenerationModal.off()}
          onProceed={() => {
            setShowLeadGenerationModal.off();
            contactMeForm.setContactMeFormData({
              show: true,
              metaData: {
                utm_term,
                utm_source,
                utm_medium,
                utm_campaign,
                utm_content
              }
            });
          }}
        />
      )}
    </HomeMain>
  );
};

export default Home;
